import React, { Component } from 'react'
import intl from 'react-intl-universal'
import Modal from '../containers/Modal'
import LoginForm from './LoginForm'

const BACKEND_AUTH_URL = 'https://auth.funoro.com'

class LoginModal extends Component {
  render () {
    return (
      <div className='b-auth-form'>
        <div className='b-form-row'>
          <a className='b-button b-button_fb b-button_x'
             href={BACKEND_AUTH_URL + '/login/facebook'}
          >
            {intl.get('Login with Facebook')}
          </a>
        </div>

        <div className='b-form-row'>
          <a className='b-button b-button_google b-button_x'
             href={BACKEND_AUTH_URL + '/login/google'}
          >
            {intl.get('Login with Google')}
          </a>
        </div>

        <div className='b-form-separator'><span>or</span></div>

        <LoginForm />

      </div>
    )
  }
}

export default LoginModal



// WEBPACK FOOTER //
// ./src/components/Login.js